import Vue from "vue";
import { withTenant, noTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.CLINIC_API_URL + "/profissional";

class ProfessionalService {
  findAll(tenant, filter) {
    let headers = noTenant();
    if (tenant) {
      headers = withTenant(tenant);
    }

    return Vue.prototype.$axios.get(apiUrl, {
      params: {
        ...filter
      },
      headers
    });
  }
}

export default new ProfessionalService();
